var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9998C10.7573 20.9998 9.58867 20.7631 8.49401 20.2898C7.39934 19.8158 6.44701 19.1725 5.63701 18.3598C4.82701 17.5471 4.18467 16.5938 3.71001 15.4998C3.23534 14.4058 2.99867 13.2391 3.00001 11.9998C3.00001 9.71647 3.74801 7.72314 5.24401 6.0198C6.74001 4.31647 8.65867 3.32647 11 3.0498V4.2798C9.00134 4.55247 7.37334 5.42614 6.11601 6.9008C4.85934 8.37614 4.23101 10.0758 4.23101 11.9998C4.23101 14.1511 4.98801 15.9838 6.50201 17.4978C8.01601 19.0118 9.84867 19.7688 12 19.7688C13.2533 19.7688 14.43 19.4908 15.53 18.9348C16.6293 18.3781 17.5167 17.6485 18.192 16.7458L19.254 17.3998C18.392 18.5345 17.336 19.4181 16.086 20.0508C14.836 20.6835 13.474 20.9998 12 20.9998ZM20.266 15.5498L19.204 14.9348C19.3793 14.5475 19.5173 14.0995 19.618 13.5908C19.7187 13.0821 19.7693 12.5518 19.77 11.9998C19.77 10.0371 19.1287 8.32147 17.846 6.8528C16.5633 5.38414 14.948 4.5268 13 4.2808V3.0498C15.2513 3.26114 17.1477 4.22847 18.689 5.9518C20.2297 7.67514 21 9.69114 21 11.9998C21 12.6565 20.94 13.2848 20.82 13.8848C20.7 14.4848 20.5153 15.0398 20.266 15.5498Z",
    fill: "#475569",
    stroke: "#475569",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageIcon);
export default __webpack_public_path__ + "static/media/usageIcon.d5ac4c1c015311f49033502e161c2ed0.svg";
export { ForwardRef as ReactComponent };